import { useState } from "react";
import axios from "axios";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";

export const Auth = () => {
  return (
    <div className="auth">
      <Login />
      <Register />
    </div>
  );
};

// Login Function
const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const [setCookies] = useCookies(["access_token"]);
  const navigate = useNavigate();

  const onSubmit = async (event) => {
    event.preventDefault();

    // Calls to backend to check for the username & password
    try {
      const response = await axios.post("http://localhost:3001/auth/login", {
        username,
        password,
      });

      // Checks if there is a response since it only outputs 'message' when it doesn't find matching user & pass
      if (!response.data.message) {
        setCookies(["access_token"], response.data.token);
        window.localStorage.setItem("userID", response.data.userID);
        navigate("/");
      } else {
        alert("Username or password is incorrect!");
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Form
      username={username}
      setUsername={setUsername}
      password={password}
      setPassword={setPassword}
      label="Login"
      onSubmit={onSubmit}
    />
  );
};

// Register Function
const Register = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const [setCookies] = useCookies(["access_token"]);
  const navigate = useNavigate();

  const onSubmit = async (event) => {
    event.preventDefault();
    if (username === "" || password === "") {
      alert("Please enter a username or password");
    }
    try {
      // Adds new username & password to backend on MongoDB
      await axios.post("http://localhost:3001/auth/register", {
        username,
        password,
      });
      // After creating new user & pass, logs in to get the access token to store in the cookies
      const response = await axios.post("http://localhost:3001/auth/login", {
        username,
        password,
      });
      setCookies(["access_token"], response.data.token);
      window.localStorage.setItem("userID", response.data.userID);
      navigate("/");
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Form
      username={username}
      setUsername={setUsername}
      password={password}
      setPassword={setPassword}
      label="Register"
      onSubmit={onSubmit}
    />
  );
};

// HTML Format for the Forms, edit the return statement to change the look
const Form = ({
  username,
  setUsername,
  password,
  setPassword,
  label,
  onSubmit,
}) => {
  return (
    <div className="auth-container">
      <form onSubmit={onSubmit}>
        <h2>{label}</h2>
        <div className="form-group">
          <label htmlFor="username">Username: </label>
          <input
            type="text"
            id="username"
            value={username}
            onChange={(event) => setUsername(event.target.value)}
          />
        </div>

        <div className="form-group">
          <label htmlFor="password">Password: </label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
        </div>

        <button type="submit">{label}</button>
      </form>
    </div>
  );
};
